import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { PageRefreshProvider } from '../context/PageRefreshContext';
import { MobileHeader } from './MobileHeader';
import { MobileTabBar } from './MobileTabBar';
import { SurveyInvite } from './SurveyInvite';

export function MobileShell() {
  const shellRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const viewport = window.visualViewport;
    let frame = 0;
    const fitCustomForm = () => {
      const shell = shellRef.current;
      if (!shell) return;
      shell.style.setProperty('--zone-visible-height', `${viewport?.height ?? window.innerHeight}px`);
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const field = document.activeElement;
        if (field instanceof HTMLElement && field.matches('.zone-custom-builder__body input')) {
          field.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
    };
    fitCustomForm();
    viewport?.addEventListener('resize', fitCustomForm);
    window.addEventListener('resize', fitCustomForm);
    document.addEventListener('focusin', fitCustomForm);
    return () => {
      cancelAnimationFrame(frame);
      viewport?.removeEventListener('resize', fitCustomForm);
      window.removeEventListener('resize', fitCustomForm);
      document.removeEventListener('focusin', fitCustomForm);
    };
  }, []);
  const pageRefreshRef = useRef<(() => void | Promise<void>) | null>(null);

  return (
    <div className="mobile-app" ref={shellRef}>
      <MobileHeader />
      <main className="mobile-app__main">
        <PageRefreshProvider refreshRef={pageRefreshRef}>
          <div className="mobile-app__scroll">
            <Outlet />
          </div>
        </PageRefreshProvider>
      </main>
      <MobileTabBar />
      <SurveyInvite />
    </div>
  );
}
